<template>
  <div
    class="c-categoryTechniqueListForSeo"
    v-if="categoryTechniqueValueListLength > 0"
  >
    <h2 class="c-categoryTechniqueListForSeo_title">
      <strong>{{ categoryName }}の{{ categoryTechniqueName }}一覧</strong>
    </h2>
    <template v-for="(item, index) in categoryTechniqueValueList">
      <div
        class="c-categoryTechniqueListForSeo_list"
        :key="item.id"
      >
        <NuxtLink :to="genTechniqueUrl(item.value)">{{ `［${categoryName}］${item.name}` }}</NuxtLink>
        <span v-if="index + 1 < categoryTechniqueValueListLength">｜</span>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CategoryTechniqueListForSeo',
  props: {
    categoryName: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters('pages/search/search', ['keyCategoryIdForTechniques']),
    ...mapGetters('master', ['getTechniqueByKeyCategoryId']),
    categoryTechnique() {
      return this.getTechniqueByKeyCategoryId(this.keyCategoryIdForTechniques)
    },
    categoryTechniqueName() {
      return this.categoryTechnique?.name || ''
    },
    categoryTechniqueValueList() {
      return this.categoryTechnique?.valuesList || []
    },
    categoryTechniqueValueListLength() {
      return this.categoryTechniqueValueList.length
    }
  },
  methods: {
    genTechniqueUrl(techniqueValue) {
      return this.$coconala.rootPathUrl(this.$route.path, {
        ...this.$route.query,
        'technique_ids[]': techniqueValue
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.c-categoryTechniqueListForSeo {
  &_title {
    margin-bottom: 8px;

    strong {
      color: $color-gray-900;
      font-size: 20px;
    }
  }
  &_list {
    display: inline-block;
    font-size: 12px;

    a {
      @include link-effect;

      color: $color-gray-800;
    }
  }
}
</style>
